export default "__VITE_ASSET__D8NnT1vE__"